module.exports = __webpack_public_path__ + "static/media/WIN1-NEW.583328bf.apng";